import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import HomeIcon from '../icons/HomeIcon';
import StatisticsIcon from '../icons/StatisticsIcon';
import ProfileIcon from '../icons/ProfileIcon';
import SettingsIcon from '../icons/SettingsIcon';
import CalcIcon from '../icons/CalcIcon';
import EvaluationTypeModal from './EvaluationTypeModal';

const navItems = [
  { icon: HomeIcon, label: 'Home', path: '/' },
  { icon: StatisticsIcon, label: 'Statistics', path: '/evaluation' },
  { icon: ProfileIcon, label: 'Profile', path: '/community' },
  { icon: SettingsIcon, label: 'Settings', path: '/services' },
  { icon: CalcIcon, label: 'Calc', path: '/calculator' },
];

const MobileBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showEvaluationModal, setShowEvaluationModal] = useState(false);
  const [activeIndex, setActiveIndex] = useState(() => {
    if (
      location.pathname === '/course-evaluation' ||
      location.pathname === '/lecturer-evaluation'
    ) {
      return 1;
    }
    const currentPath = navItems.findIndex(
      (item) => item.path === location.pathname
    );
    return currentPath >= 0 ? currentPath : 0;
  });

  const handleNavigation = (index, path) => {
    if (path === '/evaluation') {
      setShowEvaluationModal(true);
    } else {
      setActiveIndex(index);
      navigate(path);
    }
  };

  const handleSelectEvaluationType = (type) => {
    if (type === 'lecturers') {
      navigate('/lecturer-evaluation');
      setActiveIndex(1);
    } else if (type === 'courses') {
      navigate('/course-evaluation');
      setActiveIndex(1);
    }
    setShowEvaluationModal(false);
  };

  return (
    <>
      <EvaluationTypeModal
        isOpen={showEvaluationModal}
        onClose={() => setShowEvaluationModal(false)}
        onSelectEvaluationType={handleSelectEvaluationType}
      />

      <div
        className="w-full h-[60px] z-[200] flex justify-around items-center md:hidden shadow-inner bg-[rgba(177,223,255,0.05)] backdrop-blur-[50px] rounded-t-[12px]"
        style={{
          position: 'sticky',
          bottom: 0,
        }}
      >
        {navItems.map((item, index) => {
          const Icon = item.icon;
          const isActive =
            index === activeIndex ||
            (index === 1 &&
              (location.pathname === '/course-evaluation' ||
                location.pathname === '/lecturer-evaluation'));
          return (
            <button
              key={item.label}
              onClick={() => handleNavigation(index, item.path)}
              className={`flex flex-col items-center ${
                isActive ? 'text-[#28e3da]' : 'text-white'
              }`}
            >
              <Icon />
              {isActive && (
                <div className="w-4 h-[2px] bg-[#28e3da] mt-[2px] rounded-full" />
              )}
            </button>
          );
        })}
      </div>
    </>
  );
};

export default MobileBottomNav;
